<template>
  <section class="">
    <div class="d-md-flex pl-md-0 pl-2 main-container">
      <div v-for="(userStat, i) in userStatistics"
        :key="i"
        :class="userStat.customClass"
        style="width: 100%;"
      >
        <div class="card-container">
        
          <div class="d-flex align-items-center justify-content-between w-100 mb-1">
            <div>
              <div class="pb-1 text-dark" style="font-weight: 600; font-size: 16px; line-height: 21.82px; color:#202224; opacity: 0.7">{{ userStat.subtitle }}</div>
              <h2 class="text-dark" style="font-size: 28px; line-height: 38.19px; letter-spacing: 1px;">{{ userStat.value }}</h2>
            </div>
            <div>
              <UserIcons :key="userStat.icon" :icon-type="userStat.icon" />
           
            </div>
          </div>

          <div>
            <div style="font-weight: 600; font-size: 13px; line-height: 19.1px;">
             <span>
              <feather-icon v-if="userStat.progress === 'Increased'"
                icon="TrendingUpIcon"
                size="16"
                style="color:#00B69B"
              />
              <feather-icon v-else-if="userStat.progress === 'decreased'"
                icon="TrendingDownIcon"
                size="16"
                style="color:#F93C65"
              />
             </span> <span v-if="userStat.progress !== 'same'" :style="{ color: userStat.progress === 'Increased' ? '#00B69B' : '#F93C65' }">{{ userStat.progressPercentage }}</span> {{ userStat.progress }} compared to last month
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import UserIcons from "@/pages/main/home/UserIcons.vue";
import {
BAvatar,
BCard,
BCardBody,
BCardHeader,
BCardText,
BCardTitle,
BCol, BMedia, BMediaAside,
BMediaBody,
BRow,
} from 'bootstrap-vue';

export default {
  components: {
    UserIcons,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
  },
  props: {
    userStatistics: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: ""
    }
  },
}
</script>


<style lang="scss">

//my css
.card-container{
    height: 150px;
    padding:18px;
}

//end of css

p {
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 3px !important;
}

.user-stat-card {
  border-radius: 10px;
  margin-left: 20px;

  .icon-card {
    width: 75px;
    height: 75px;
    margin-left: -18%;
  }

  @media screen and (max-width: 992px) {
    margin-left: 0;
  }
}

.user-stat-card-first {
  border-radius: 10px;

  .icon-card {
    width: 75px;
    height: 75px;
    margin-left: -18%;
  }
}

.users {
  .icon-card {
    background-color: #aedaf9;
  }
}
.verified {
  .icon-card {
    background-color: #E6F5ED;
  }
}

.unverified {
  .icon-card {
    background-color: #FCE9E9;
  }
}

.subscriptions {
  .icon-card {
    background-color: #D6FBFF;
  }
}


.dark-layout {

  .users {
    .icon-card {

      background-color: #404A5B;
    }
  }
  .verified {
    .icon-card {
      background-color: #6A7580;
    }
  }

  .unverified {
    .icon-card {
      background-color: #72717E;
    }
  }

  .subscriptions {
    .icon-card {
      //background-color: rgb(214, 251, 255, 0.30);
      background-color: #5D6E7D;
    }
  }


}

@media screen and (max-width: 992px) {
  .main-container{
    padding-left: 0!important;
  }
}


</style>
